<template>
  <b-notification :closable="false">
    {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-1') }}
    <ul style="list-style-type: square; margin-left: 25px">
      <li>{{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-li-1') }}</li>
      <li>{{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-li-2') }}</li>
    </ul>
    {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-2') }}<br />
    {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-3') }}<br />
    {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-4') }}
    <br /><br />
    <b
      ><em>{{
        $t('compCarbonFormsFoodsHelpCalculatingMethod.text-ex-tit')
      }}</em></b
    ><br />
    {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-ex-1') }}
    <ul style="list-style-type: none; margin-left: 25px">
      <li>
        {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-ex-1-li-1') }}
      </li>
      <li>
        {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-ex-1-li-2') }}
      </li>
    </ul>
    {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-ex-2') }}
    <ul style="list-style-type: none; margin-left: 25px">
      <li>
        {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-ex-2-li-1') }}
      </li>
      <li>
        {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-ex-2-li-2') }}
      </li>
      <li>
        {{ $t('compCarbonFormsFoodsHelpCalculatingMethod.text-ex-2-li-3') }}
      </li>
    </ul>
  </b-notification>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
